import { allowedPermissions as adminsPermissions } from '../admins';
import { allowedPermissions as campaignDomainsPermissions } from '../campaign-domains';
import { allowedPermissions as programsPermissions } from '../programs/list';
import { allowedPermissions as threadsPermissions } from '../threads/list';
import { allowedPermissions as affiliatesPermissions } from '../affiliates/list';
import { allowedPermissions as newsPermissions } from '../news/list';
import { allowedPermissions as discountsPermissions } from '../discounts/list';
import { allowedPermissions as payoutSystemsPermissions } from '../payout-systems';
import { allowedPermissions as landingSnippetsPermissions } from '../landing-snippets';
import { allowedPermissions as payoutsPermissions } from '../payouts/list';
import { allowedPermissions as affiliatesActivityPermissions } from '../affiliates-activity';
import { allowedPermissions as statisticsPermissions } from '../statistics/general';
import { allowedPermissions as promoReportsPermissions } from '../promo-reports';
import { allowedPermissions as definedReferersPermissions } from '../defined-referers';
import { allowedPermissions as extThreadsPermissions } from '../external-threads/list';
import { allowedPermissions as campaignsPermissions } from '../campaigns';
import { allowedPermissions as unacceptableConversionsPermissions } from '../statistics/unacceptable-conversions';
import { allowedPermissions as pollsPermissions } from '../polls';
import { allowedPermissions as wmPermissions } from '../wm';
import { allowedPermissions as advRequest } from '../advertisers-requests/list/index';
import { allowedPermissions as affiliatesRedeemPermissions } from '../affiliates-redeem';
import { allowedPermissions as payoutRequestsPermission } from '../payout-requests/list-request';
import { allowedPermissions as productivityPermissions } from '../affiliate-managers-productivity';
import { allowedPermissions as trafficAccountingPermissions } from '../traffic-accounting';
import { allowedPermissions as conversionsApprovePermissions } from '../conversions-approve';
import { allowedPermissions as conversionsApproveRequestsPermissions } from '../conversions-approve-requests';
import { allowedPermissions as guarantApproveRequestsPermissions } from '../guarant-approve-register/editor';
import { allowedPermissions as garantForecastPermissions } from '../garant-forecast';
import {
	allowedPermissions as conversionGarantApproveRequestsPermissions
} from '../conversions-garant-approve-requests';
import { allowedPermissions as payoutLogPermissions } from '../payout-log/transfers';
import { allowedPermissions as finReports } from '../fin-reports';
import { allowedPermissions as landingReports } from '../landing-reports';
import { allowedPermissions as affiliateReports } from '../affiliate-reports';
import { allowedPermissions as chainPage } from '../chaining/list';
import { allowedPermissions as topAffiliates } from '../top-affiliates';
import { allowedPermissions as topOffers } from '../top-offers';
import { allowedPermissions as goodsPermissions } from '../goods/list';
import { allowedPermissions as bmAccountsPermissions } from '../bm-accounts/list';
import { allowedPermissions as marketingReportPermissions } from '../marketing-reports';
import { allowedPermissions as exchangeRatesPermissions } from '../exchange-rates';
import { allowedPermissions as ranksPointsReportPermissions } from '../ranks-points-report';
import { allowedPermissions as cplRulesPermissions } from '../cpl-rules';
import { allowedPermissions as approvedRejectPermissions } from '../approve-reject';
import { allowedPermissions as geoPayoutRatesPermissions } from '../geo-payout-rates';
import { allowedPermissions as contestPermissions } from '../contests';
import { allowedPermissions as missionsPermissions } from '../missions/list';

import { enum as permissions } from '../../../../../enums/admin-permissions';

export default {
	'viewGoods': goodsPermissions.view,
	'viewBmAccounts': bmAccountsPermissions.view,
	'viewAdmins': adminsPermissions.view,
	'viewCampaignDomains': campaignDomainsPermissions.view,
	'viewPrograms': programsPermissions.view,
	'viewThreads': threadsPermissions.view,
	'viewAffiliates': affiliatesPermissions.view,
	'affiliateIdsList': affiliatesPermissions.viewIds,
	'viewNews': newsPermissions.view,
	'viewDiscounts': discountsPermissions.view,
	'autotrashView': unacceptableConversionsPermissions.autotrash_view,
	'autotrashResend': unacceptableConversionsPermissions.resend,
	'missionsView': missionsPermissions.view,
	'viewPayoutSystems': payoutSystemsPermissions.view,
	'viewLandingSnippets': landingSnippetsPermissions.view,
	'viewPayouts': payoutsPermissions.view,
	'viewAffiliatesActivity': affiliatesActivityPermissions.view,
	'viewAnalytics': statisticsPermissions.view,
	'viewPromoReports': promoReportsPermissions.promo_report_view,
	'viewMailings': permissions.mailingsList,
	'viewDefinedReferers': definedReferersPermissions.view,
	'viewExtThreads': extThreadsPermissions.view,
	'viewCampaigns': campaignsPermissions.view,
	'viewPolls': pollsPermissions.view,
	'viewWM': wmPermissions.view,
	'viewAdvRequests': advRequest.view,
	'viewAffiliatesRedeem': affiliatesRedeemPermissions.view,
	'viewPersonalPayoutRequests': payoutRequestsPermission.payout_requests_personal_view,
	'viewAllPayoutRequests': payoutRequestsPermission.payout_requests_view_all,
	'payoutRequestsViewMatrixAndHistory': payoutRequestsPermission.payout_requests_view_matrix_and_history,
	'affiliateManagersProductivityListAll': productivityPermissions.affiliateManagersProductivityListAll,
	'affiliateManagersProductivityShowMe': productivityPermissions.affiliateManagersProductivityShowMe,
	'trafficAccountingView': trafficAccountingPermissions.trafficAccountingView,
	'viewConversionsApprove': conversionsApprovePermissions.manual,
	'viewConversionsApproveRequests': conversionsApproveRequestsPermissions.view,
	'viewFinReports': finReports.view,
	'viewLandingReports': landingReports.view,
	'viewAffiliateReports': affiliateReports.view,
	'viewPayoutLog': payoutLogPermissions.view,
	'viewChainPage': chainPage.view,
	'topAffiliatesViewAll': topAffiliates.viewAll,
	'affiliateMonthlyReportView': topAffiliates.monthlyReportView,
	'canCopyTotalRow': topAffiliates.canCopyTotalRow,
	'topOffersViewAll': topOffers.viewAll,
	'viewMarketingReports': marketingReportPermissions.view,
	'contestView': contestPermissions.contestView,
	'viewExchangeRates': exchangeRatesPermissions.view,
	'viewRanksPointsReport': ranksPointsReportPermissions.view,
	banners: permissions.banners,
	popups: permissions.popups,
	blog: permissions.blog,
	'cplRulesList': cplRulesPermissions.cplRulesList,
	'guarantRegisterView': guarantApproveRequestsPermissions.view,
	'garantForecastView': garantForecastPermissions.view,
	'garantApproveRequestsView': conversionGarantApproveRequestsPermissions.view,
	'garantApproveRequestsApprove': conversionGarantApproveRequestsPermissions.confirm,
	'cplRulesEdit': cplRulesPermissions.cplRulesEdit,
	'approvedRejectedPayoutsList': approvedRejectPermissions.approvedRejectPayoutsList,
	'approvedRejectedPayoutsEdit': approvedRejectPermissions.approvedRejectPayoutsEdit,
	'geoPayoutRatesList': geoPayoutRatesPermissions.geoPayoutRatesList,
	'geoPayoutRatesEdit': geoPayoutRatesPermissions.geoPayoutRatesEdit,
	managersAffiliatesActivity: permissions.managersAffiliatesActivity,
	registrationAnalytics: permissions.registrationAnalytics,
	alertsAnalytics: permissions.alertsAnalytics,
	conversionsApproveDaily: permissions.conversionsApproveDaily,
	marketingFunnel: permissions.marketingFunnel,
	priorities: permissions.priorities,
	weeklyReport: permissions.weeklyReport,
	quidsReport: permissions.quidsReport,
	productCap: permissions.productCap
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/permissions.js